import { Alert, Box, CircularProgress, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from "react";

const useLoadingStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(2),
        height: '100%',
    }
}));
const NotificationStringLoading = (props) => {
    const classes = useLoadingStyles();

    React.useEffect(() => {
        const tm = setTimeout(() => props.res.api.refresh(), 1000);
        return () => clearTimeout(tm);
    });

    return <Box className={classes.root} display="flex" alignItems="flex-start" justifyContent="center" >
        <Alert severity="info" icon={false}>
            <Grid container direction="row" spacing={4} alignItems="center">
                <Grid item xs={2}><CircularProgress color="primary"/></Grid>
                <Grid item xs={10}>Notification string is loading. Please wait...</Grid>
            </Grid>
        </Alert>
    </Box>;
}

export default NotificationStringLoading;
